import * as React from "react";
import { FormattedNumber } from "react-intl";
import { CyMath } from "./math";

const format = "en-US";
const currency = "USD";

function NumberFormatter(value) {
  return new Intl.NumberFormat(format).format(value);
}

function CurrencyFormatter(value) {
  const val = new Intl.NumberFormat(format, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
  return val;
}

function PercentageParser(value) {
  return `${CyMath.roundTwoDecimal(value * 100)}%`
}

/*
  Parse currency to number
  ex) $35,000 to 35000
*/
function CurrencyParser(value) {
  return Number(value.replace(/[^0-9.-]+/g, ""));
}

function NumberTransformer(props) {
  const { children, value } = props;
  if (children) {
    return (
      <FormattedNumber
        value={value}
        maximumFractionDigits={CyMath.isFloat(value) ? 2 : 0}
      >
        {children}
      </FormattedNumber>
    );
  } else {
    return (
      <FormattedNumber
        value={value}
        maximumFractionDigits={CyMath.isFloat(value) ? 2 : 0}
      />
    );
  }
}
/* eslint-disable*/
function CurrencyTransformer(props) {
  const { children, value } = props;
  if (children) {
    return (
      <FormattedNumber
        value={value}
        currency={currency}
        style="currency"
        minimumFractionDigits={0}
        maximumFractionDigits={CyMath.isFloat(value) ? 2 : 0}
      >
        {children}
      </FormattedNumber>
    );
  } else {
    return (
      <FormattedNumber
        value={value}
        currency={currency}
        style="currency"
        minimumFractionDigits={0}
        maximumFractionDigits={CyMath.isFloat(value) ? 2 : 0}
      />
    );
  }
}

function PercentageTransformer(props) {
  const { children, value } = props;
  if (children) {
    return (
      <FormattedNumber
        value={value}
        style="percent"
        minimumFractionDigits={0}
        maximumFractionDigits={2}
      >
        {children}
      </FormattedNumber>
    );
  } else {
    return (
      <FormattedNumber
        value={value}
        style="percent"
        minimumFractionDigits={0}
        maximumFractionDigits={2}
      />
    );
  }
}
/* eslint-enable*/

export const CyNumber = {
  NumberFormatter,
  CurrencyFormatter,
  NumberTransformer,
  CurrencyTransformer,
  PercentageTransformer,
  CurrencyParser,
  PercentageParser
};



// WEBPACK FOOTER //
// ./src/utilities/number.js